import { Swiper } from 'swiper';
import { Autoplay, Navigation, Pagination, Keyboard } from 'swiper/modules';

document.querySelectorAll( '.phone-slider' ).forEach( ( slider ) => {
	const swiperEl = slider.querySelector( '.phone-slider__swiper' );
	if ( ! swiperEl ) return;

	let opts = {};
	try { opts = JSON.parse( swiperEl.dataset.swiper || '{}' ); } catch ( e ) { /* */ }

	const slideCount = slider.querySelectorAll( '.swiper-slide' ).length;

	// Initialize Swiper with loop + centeredSlides
	const swiper = new Swiper( swiperEl, {
		modules:     [ Autoplay, Navigation, Pagination, Keyboard ],
		...opts,

		// Loop configuration
		loop:                    true,

		// Autoplay
		autoplay: {
			delay:                  3000,
			disableOnInteraction:   true,
		},

		// Slide display
		slidesPerView:           'auto',
		centeredSlides:          true,
		spaceBetween:            40,
		keyboard:                true,

		// Navigation & pagination
		navigation: {
			prevEl: slider.querySelector( '.phone-slider__prev' ),
			nextEl: slider.querySelector( '.phone-slider__next' ),
		},
		pagination: {
			el:                slider.querySelector( '.phone-slider__dots' ),
			bulletClass:       'phone-slider__dot',
			bulletActiveClass: 'is-active',
			clickable:         true,
			// renderBullet:      ( i, cls ) => `<button class="${ cls }" type="button" data-slide="${i}"><span style="font-size: 10px; font-weight: bold;">${i}</span></button>`,
		},
	} );

	swiper.on( 'beforeSlideChangeStart', () => {
		// Only stop autoplay if it's actually running (i.e., not already stopped)
		if ( swiper.autoplay.running ) {
			swiper.autoplay.stop();
		}
	} );

	// Resume autoplay after slide transition completes
	swiper.on( 'slideChangeTransitionEnd', () => {
		swiper.autoplay.start();
	} );

	// Log slide changes for debugging
	// swiper.on( 'slideChange', () => {
	// 	console.log( `[Phone Slider] activeIndex: ${swiper.activeIndex}, realIndex: ${swiper.realIndex}` );
	// } );
} );
